// extracted by mini-css-extract-plugin
export var root = "MarkdownInset-module--root--191ed";